export default class RequestNetworkProblemError extends Error {
    constructor(url, requestInit, originalError) {
        super(`Network problem: ${url} - ${originalError}`);
        this.name = 'RequestNetworkProblemError';
        this.url = url;
        this.requestInit = requestInit;
        this.originalError = originalError;
    }
}
